export const editorials: string[] = [
  'That Book',
  'Líderes',
];
